import { useMediaQuery } from "@mui/material";

export function useIsSmallScreen() {
  return useMediaQuery("(max-width:600px)");
}
